import React from 'react';
import { IconButton, useColorMode, Tooltip } from '@chakra-ui/react';
import { SunIcon, MoonIcon } from '@chakra-ui/icons';

const ColorModeToggle = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Tooltip label={colorMode === 'light' ? 'Dark mode' : 'Light mode'}>
      <IconButton
        size="sm"
        variant="ghost"
        icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
        onClick={toggleColorMode}
        aria-label={`Toggle ${colorMode === 'light' ? 'Dark' : 'Light'} Mode`}
      />
    </Tooltip>
  );
};

export default ColorModeToggle;
